import UploadField from "./field-upload";
import SelectMultipleRemoteWidget from "./widget-selectMultipleRemote";
import Comments from "./Comments/Comments";


const fields = {
  UploadField: UploadField,
  SelectMultipleRemoteWidget: SelectMultipleRemoteWidget,
  Comments: Comments,
};

export default fields;


// WEBPACK FOOTER //
// ./src/lib/fields.js